module.exports = __webpack_public_path__ + "static/media/x-icon.d514d5d0.svg";